var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { SocialProviderTypes } from 'core/socialProviderTypes';
import { provider } from 'src/socialEngine';
import { take, fork, select, put, call, cancelled, all } from 'redux-saga/effects';
import { CommentActionType } from 'constants/commentActionType';
import { authorizeSelector } from 'store/reducers/authorize/authorizeSelector';
import { serverActions, commentActions, postActions } from 'store/actions';
import CommentAPI from 'api/CommentAPI';
import { eventChannel } from 'redux-saga';
import { ServerRequestStatusType } from 'store/actions/serverRequestStatusType';
import { postSelector } from 'store/reducers/posts/postSelector';
import { Map } from 'immutable';
/**
 * Get service providers
 */
var commentService = provider.get(SocialProviderTypes.CommentService);
/***************************** Subroutines ************************************/
/**
 * Creating channel event and subscribing get comments service
 */
function fetchCommentsChannel(postId) {
    return eventChannel(function (emmiter) {
        var unsubscribe = commentService.getComments(postId, function (comments) {
            emmiter(comments);
        });
        return function () {
            unsubscribe();
        };
    });
}
/**
 * Set comments in store
 */
function setComments(ownerId, postId, comments) {
    var commentsCount, post, desiredComments, sortedObjects, updatedPost;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: 
            /**
             * Workout getting the number of post's comment and getting three last comments
             */
            return [4 /*yield*/, put(commentActions.addCommentList(comments))];
            case 1:
                /**
                 * Workout getting the number of post's comment and getting three last comments
                 */
                _a.sent();
                return [4 /*yield*/, select(postSelector.getPost, ownerId, postId)];
            case 2:
                post = _a.sent();
                if (!post) return [3 /*break*/, 5];
                desiredComments = comments[postId];
                if (!desiredComments) return [3 /*break*/, 5];
                commentsCount = Object.keys(desiredComments).length;
                return [4 /*yield*/, CommentAPI.sortCommentsByDate(desiredComments)];
            case 3:
                sortedObjects = _a.sent();
                updatedPost = post.set('comments', Map(sortedObjects))
                    .set('commentCounter', commentsCount);
                return [4 /*yield*/, put(postActions.updatePost(updatedPost))];
            case 4:
                _a.sent();
                _a.label = 5;
            case 5: return [2 /*return*/];
        }
    });
}
/**
 * Fetch comments from the server
 */
function dbFetchComments(ownerId, postId) {
    var currentUser, getCommentsRequest, channelSubscription, comments, comments_1;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, select(authorizeSelector.getCurrentUser)];
            case 1:
                currentUser = _a.sent();
                getCommentsRequest = CommentAPI.createGetCommentsRequest(postId);
                return [4 /*yield*/, put(serverActions.sendRequest(getCommentsRequest))];
            case 2:
                _a.sent();
                return [4 /*yield*/, call(fetchCommentsChannel, postId)];
            case 3:
                channelSubscription = _a.sent();
                return [4 /*yield*/, take(channelSubscription)];
            case 4:
                comments = _a.sent();
                getCommentsRequest.status = ServerRequestStatusType.OK;
                return [4 /*yield*/, call(setComments, ownerId, postId, comments)];
            case 5:
                _a.sent();
                return [4 /*yield*/, put(serverActions.sendRequest(getCommentsRequest))];
            case 6:
                _a.sent();
                _a.label = 7;
            case 7:
                _a.trys.push([7, , 12, 14]);
                _a.label = 8;
            case 8:
                if (!true) return [3 /*break*/, 11];
                return [4 /*yield*/, take(channelSubscription)];
            case 9:
                comments_1 = _a.sent();
                return [4 /*yield*/, call(setComments, ownerId, postId, comments_1)];
            case 10:
                _a.sent();
                return [3 /*break*/, 8];
            case 11: return [3 /*break*/, 14];
            case 12: return [4 /*yield*/, cancelled()];
            case 13:
                if (_a.sent()) {
                    channelSubscription.close();
                }
                return [7 /*endfinally*/];
            case 14: return [2 /*return*/];
        }
    });
}
/******************************************************************************/
/******************************* WATCHERS *************************************/
/******************************************************************************/
function watchFetchComments() {
    var payload, ownerUserId, postId;
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0:
                if (!true) return [3 /*break*/, 3];
                return [4 /*yield*/, take(CommentActionType.DB_FETCH_COMMENTS)];
            case 1:
                payload = (_a.sent()).payload;
                ownerUserId = payload.ownerUserId, postId = payload.postId;
                return [4 /*yield*/, fork(dbFetchComments, ownerUserId, postId)];
            case 2:
                _a.sent();
                return [3 /*break*/, 0];
            case 3: return [2 /*return*/];
        }
    });
}
export default function commentSaga() {
    return __generator(this, function (_a) {
        switch (_a.label) {
            case 0: return [4 /*yield*/, all([
                    watchFetchComments()
                ])];
            case 1:
                _a.sent();
                return [2 /*return*/];
        }
    });
}



//////////////////
// WEBPACK FOOTER
// ./src/store/sagas/commentSaga.ts
// module id = 892
// module chunks = 50